module.exports = __webpack_public_path__ + "bed-button-create.15e8d90f.png";